import { Type } from '@angular/core'

import { Cmp } from 'app/core/cms/type-unions'

import { CmsBlock } from '../cms-block'
import { CmpCtaComponent } from './cmp-cta/cmp-cta.component'
import { CmpImageComponent } from './cmp-image/cmp-image.component'
import { CmpImgCarouselComponent } from './cmp-img-carousel/cmp-img-carousel.component'
import { CmpLatestNewsComponent } from './cmp-latest-news/cmp-latest-news.component'
import { CmpNewsletterSubscriptionComponent } from './cmp-newsletter-subscription/cmp-newsletter-subscription.component'
import { CmpRichTextComponent } from './cmp-richtext/cmp-rich-text.component'
import { CmpTestimonialComponent } from './cmp-testimonial/cmp-testimonial.component'
import { CmpTitleComponent } from './cmp-title/cmp-title.component'
import { CmpVideoComponent } from './cmp-video/cmp-video.component'

type CmpMapping = {
  [key in Cmp['__typename']]: Type<CmsBlock<Cmp & { __typename: key }>>
}

export const CMP_MAPPING = {
  CmpTitle: CmpTitleComponent,
  CmpRichText: CmpRichTextComponent,
  CmpImage: CmpImageComponent,
  CmpVideo: CmpVideoComponent,
  CmpCta: CmpCtaComponent,
  CmpImgCarousel: CmpImgCarouselComponent,

  CmpLatestNews: CmpLatestNewsComponent,
  CmpNewsletterSubscription: CmpNewsletterSubscriptionComponent,
  CmpTestimonial: CmpTestimonialComponent,
} as const satisfies CmpMapping
